var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vbst-item list-group-item list-group-item-action",attrs:{"tabindex":"0"}},[_vm._t("default",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})],null,{ data: _vm.data, htmlText: _vm.htmlText })],2)}
var staticRenderFns = []

export { render, staticRenderFns }